export default {
  fontFamily: "'Chinese Quote',-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei','Helvetica Neue',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  colors: {
    main: '#4a4a4a',
    white: '#ffffff',
    secondary: '#9b9b9b',
    lightGray: '#f8f9fa',
    primary: '#1890ff',
    darkPrimary: '#096dd9',
    semiPrimary: '#CFCFFF',
    lightPrimary: '#91d5ff',
    lighterPrimary: '#e6f7ff',
    focusPrimary: '#40a9ff',
    focusPrimaryText: '#dedeff',
    border: '#e3e3e3',
    success: '#66bb6a',
    darkSuccess: '#237804',
    danger: '#ff4d4f',
    darkDanger: '#c61322',
    darkerDanger: '#d01d2d',
    lightDanger: '#fcd1d5',
    warning: '#ffc53d',
    darkWarning: '#ddb800',
    lightWarning: '#fff7cd',
    lighterBackground: '#f4f5fb',
    mainBackground: '#f5f5f5',
    darkerBackground: '#fff',
    gray: '#595959',
    lighterGray: '#f2f3fa',
    info: '#17a2b8',
    black: '#343a40',
    darkGray: '#212529',
    darkerGray: '#e2e4ee',
    veryLightGrey: '#cdcdcd',
    darkestGray: '#cbcedc',
    placeholder: '#808080',
  },
  layout: {
    phone: 540,
    tablet: 720,
    smallDesktop: 960,
    largeDesktop: 1140,
  },
  borderRadius: '6px',
  borderCircle: '100vw',
  borderSmall: '4px',
  gridGap: 15,
  tablePadding: 8,
};
